export default __webpack_public_path__ + "static/media/chartres3.531b56ed.jpg";